import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconSmile: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? "22"}
      height={height ?? "22"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.65039 12.6499C6.65039 12.6499 8.15039 14.6499 10.6504 14.6499C13.1504 14.6499 14.6504 12.6499 14.6504 12.6499M7.65039 7.6499H7.66039M13.6504 7.6499H13.6604M20.6504 10.6499C20.6504 16.1728 16.1732 20.6499 10.6504 20.6499C5.12754 20.6499 0.650391 16.1728 0.650391 10.6499C0.650391 5.12705 5.12754 0.649902 10.6504 0.649902C16.1732 0.649902 20.6504 5.12705 20.6504 10.6499Z"
        stroke={color ?? "#050038"}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
